import { useState } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';
import { useAppDispatch } from '../../store/hooks';
import { useNavigate } from 'react-router-dom';
import { userLogout } from '../../utility/helpers';

const SignOut = ({
    showSignOut,
    setShowSignOut
}: any) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [isSigningOut, setIsSigningOut] = useState(false);

    const handleClose = () => {
        if (isSigningOut) {
            return;
        }
        setIsSigningOut(false);
        setShowSignOut(false);
    };

    const handleSignOut = async () => {
        if (isSigningOut) {
            return;
        }
        setIsSigningOut(true);
        try {
            await userLogout(navigate, dispatch);
        } catch (error) {
            console.info('Sign out failed unexpectedly:', error);
            setIsSigningOut(false);
        }
    };
    return (
        <>
            < Modal show={showSignOut}
                    onHide={handleClose}
                    backdrop={isSigningOut ? 'static' : true}
                    keyboard={!isSigningOut}
                    dialogClassName="modal-signout top-right-modal modal-dialog-centered "
                    className="confirmation-modal sign-up-modal"
            >
                <Modal.Body>
                    {isSigningOut ? (
                        <div className="signout-loading-wrap" aria-live="polite" aria-busy="true">
                            <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Signing out...</span>
                            </div>
                            <p className="spinner-load-text">Signing out...</p>
                        </div>
                    ) : (
                        <>
                            <h4 className="modal-head modal-head-medium">Sign Out</h4>
                            <p className='modal-subhead'>Are you sure you want to sign out?</p>
                            <div className='form-wrap'>
                                <Form className="full-width-form">
                                    <div className="sign-btn-wrapper">
                                        <Button variant="primary" onClick={handleSignOut} disabled={isSigningOut} className="submit-btn scale">
                                            yes, sign out
                                        </Button>
                                        <Button variant="primary" className="btn-cancel not-now-btn" onClick={handleClose} disabled={isSigningOut}>
                                            not now
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </ Modal>
        </>
    );
};

export default SignOut;
